import "scripts/templates/page.international-english.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.international-english");
